// 老师介绍页

import axios from '../utils/fetch';

export const getTeaCherInfo = (options) => {
  return axios.get('/api/zmbiz-teacher-h5-api/teacherEvaluation/getIntroduceView', options);
};

export const getTeacherStudentComments = (options) => {
  return axios.get('/api/zmbiz-teacher-h5-api/teacherEvaluation/getTeacherEvaluations', options);
};

export const getIPLocation = (options) => {
  return axios.get('/api/zmbiz-teacher-h5-api/teacherEvaluation/getIPLocation', options);
};

export const getAddressMock = (options) => {
  return axios.get('/api/zmbiz-teacher-h5-api/teacherEvaluation/getAddressMock', options);
};

export const verificateTeacherMaskMobile = (options) => {
  return axios.post('/api/zmbiz-teacher-h5-api/common/verificateTeacherMaskMobile', options);
  // return axios.post('/api/zmbiz-csc-frontend-sale/outer/initGeetest', options);
  // return axios.get(`${process.env.VUE_APP_API_ADMIN_H5TAWAY || ''}/teacherEvaluation/getIntroduceView`, options);
};

// 获取科目列表
export const getSubjectList = (options) => {
  return axios.post('/api/zmbiz-csc-frontend-sale/outer/get-phase-subject', options)
};

// 获取svip老师列表
export const pageSvipTeacher = (options) => {
  return axios.post('/api/zmbiz-csc-frontend-sale/outer/page-svip-teacher', options);
};

// 根据token获取userId
export const receiveNowH5UserId = (options) => {
  return axios.post('/api/zmbiz-csc-frontend-sale/outer/token-check-student', options);
};

// 用户点击预约
export const studentApplyTeacher = (options) => {
  return axios.post('/api/zmbiz-csc-frontend-sale/outer/student-apply-teacher', options);
};
